import React from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/table";
import { TailSpin } from "react-loader-spinner";



const RolesTable = ({ data }: any) => {
  const navigate = useNavigate()
  
  const columns = [
    { header: "Name", accessor: "name" },
    { header: " Created At", accessor: "created_at" },
    { header: "View", accessor: "id" },
  ];

  const handleUserClick = (_id: string) => {
    navigate(`/roles/detail/${_id}`)
  };

  return (
    <div className="rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 ">
      <div className="flex justify-between">
        <p className="text-[18px] font-semibold">All Accounts</p>
      </div>

      {data?.length > 0 ? (
        <Table
          columns={columns}
          data={data}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className="opacity-80 mt-10 font-bold w-[4%] mx-auto">
          <TailSpin color="skyblue" />
        </div>
      )}

     
    </div>
  );
};

export default RolesTable;
